import React, { useState, useRef, useEffect, useCallback } from 'react';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import {
  Alert,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import {
  CalculateOutlined,
  CleaningServices,
  SaveAlt,
  WarningAmberRounded,
  CheckCircleOutlineRounded,
} from '@mui/icons-material';
import { calculateSeismicParameters } from '../utils/seismicCalculations';
import {
  AnalisisSismico,
  FACTORES_ESTRUCTURALES,
  CATEGORIAS_RIESGO,
} from '../utils/seismicParameters';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const areasDefinidas = [
  {
    "name": "(2)CFZ",
    "points": [
      [
        -71.09034109262848,
        19.925207082881812
      ],
      [
        -70.98966425228697,
        19.882120216032792
      ],
      [
        -70.91415662203084,
        19.87134849932054
      ],
      [
        -70.8386489917747,
        19.833647490827648
      ],
      [
        -70.7599952102579,
        19.801332340690884
      ],
      [
        -70.6813414287411,
        19.774403048910244
      ],
      [
        -70.59954149596362,
        19.758245473841864
      ],
      [
        -70.49571850436145,
        19.736702040417352
      ],
      [
        -70.43908778166934,
        19.736702040417352
      ],
      [
        -70.39818781528061,
        19.736702040417352
      ],
      [
        -70.37301860519523,
        19.736702040417352
      ],
      [
        -70.31638788250314,
        19.69900103192446
      ],
      [
        -70.30694942872111,
        19.655914165075444
      ],
      [
        -70.30380327746045,
        19.634370731650932
      ],
      [
        -70.39189551275926,
        19.63975659000706
      ],
      [
        -70.46425699175472,
        19.64514244836319
      ],
      [
        -70.53661847075018,
        19.655914165075444
      ],
      [
        -70.61212610100631,
        19.666685881787696
      ],
      [
        -70.67819527748043,
        19.666685881787696
      ],
      [
        -70.7599952102579,
        19.69900103192446
      ],
      [
        -70.84179514303538,
        19.7259303237051
      ],
      [
        -70.92044892455218,
        19.763631332197992
      ],
      [
        -70.99595655480832,
        19.790560623978628
      ],
      [
        -71.04944112623974,
        19.80671819904701
      ],
      [
        -71.09348724388914,
        19.822875774115392
      ],
      [
        -71.12494875649587,
        19.82826163247152
      ],
      [
        -71.15326411784191,
        19.849805065896028
      ],
      [
        -71.15011796658125,
        19.876734357676664
      ],
      [
        -71.09034109262848,
        19.925207082881812
      ]
    ]
  },
  {
    "name": "(3)SFZ",
    "points": [
      [
        -71.6063098993787,
        19.946750516306324
      ],
      [
        -71.52136381534056,
        19.952136374662448
      ],
      [
        -71.48046384895181,
        19.946750516306324
      ],
      [
        -71.43012542878107,
        19.919821224525684
      ],
      [
        -71.37664085734964,
        19.898277791101176
      ],
      [
        -71.3357408909609,
        19.876734357676664
      ],
      [
        -71.27596401700814,
        19.855190924252156
      ],
      [
        -71.23191789935872,
        19.833647490827648
      ],
      [
        -71.16899487414528,
        19.812104057403136
      ],
      [
        -71.09977954641049,
        19.795946482334756
      ],
      [
        -71.05573342876109,
        19.779788907266372
      ],
      [
        -71.00539500859033,
        19.752859615485736
      ],
      [
        -70.95505658841958,
        19.731316182061228
      ],
      [
        -70.87954895816344,
        19.688229315212208
      ],
      [
        -70.83235668925336,
        19.672071740143824
      ],
      [
        -70.74426445395454,
        19.628984873294804
      ],
      [
        -70.67504912621976,
        19.60205558151417
      ],
      [
        -70.59639534470296,
        19.569740431377404
      ],
      [
        -70.53032616822884,
        19.53742528124064
      ],
      [
        -70.43594163040868,
        19.510495989460004
      ],
      [
        -70.33526479006717,
        19.472794980967112
      ],
      [
        -70.21571104216163,
        19.43509397247422
      ],
      [
        -70.08986499173474,
        19.408164680693584
      ],
      [
        -69.98289584887189,
        19.370463672200692
      ],
      [
        -69.8696344034877,
        19.34892023877618
      ],
      [
        -69.8004190757529,
        19.33814852206393
      ],
      [
        -69.76266526062484,
        19.3327626637078
      ],
      [
        -69.64940381524065,
        19.305833371927164
      ],
      [
        -69.55501927742048,
        19.29506165521491
      ],
      [
        -69.47007319338233,
        19.284289938502653
      ],
      [
        -69.38512710934418,
        19.262746505078145
      ],
      [
        -69.32535023539141,
        19.257360646722017
      ],
      [
        -69.26871951269932,
        19.25197478836589
      ],
      [
        -69.22152724378924,
        19.23581721329751
      ],
      [
        -69.22781954631058,
        19.20350206316074
      ],
      [
        -69.28130411774201,
        19.20350206316074
      ],
      [
        -69.41658862195091,
        19.219659638229125
      ],
      [
        -69.51726546229241,
        19.241203071653633
      ],
      [
        -69.63367305893728,
        19.24658893000976
      ],
      [
        -69.63367305893728,
        19.198116204804613
      ],
      [
        -69.74693450432147,
        19.225045496585253
      ],
      [
        -69.79727292449223,
        19.225045496585253
      ],
      [
        -69.8696344034877,
        19.241203071653633
      ],
      [
        -69.95772663878651,
        19.257360646722017
      ],
      [
        -70.048965025346,
        19.284289938502653
      ],
      [
        -70.16537262199087,
        19.31121923028329
      ],
      [
        -70.27234176485372,
        19.343534380420053
      ],
      [
        -70.36987245393456,
        19.381235388912945
      ],
      [
        -70.45167238671203,
        19.402778822337456
      ],
      [
        -70.52718001696816,
        19.43509397247422
      ],
      [
        -70.60583379848497,
        19.467409122610984
      ],
      [
        -70.7946028741253,
        19.548196997952896
      ],
      [
        -70.8386489917747,
        19.55896871466515
      ],
      [
        -70.98337194976563,
        19.628984873294804
      ],
      [
        -71.17528717666663,
        19.720544465348972
      ],
      [
        -71.21933329431603,
        19.720544465348972
      ],
      [
        -71.31686398339687,
        19.720544465348972
      ],
      [
        -71.40181006743502,
        19.74208789877348
      ],
      [
        -71.4836100002125,
        19.774403048910244
      ],
      [
        -71.56855608425064,
        19.801332340690884
      ],
      [
        -71.63147910946408,
        19.817489915759264
      ],
      [
        -71.67237907585282,
        19.833647490827648
      ],
      [
        -71.72586364728424,
        19.849805065896028
      ],
      [
        -71.66923292459215,
        19.892891932745048
      ],
      [
        -71.67237907585282,
        19.93059294123794
      ],
      [
        -71.65664831954946,
        19.935978799594068
      ],
      [
        -71.63777141198543,
        19.93059294123794
      ],
      [
        -71.6063098993787,
        19.946750516306324
      ]
    ]
  },
  {
    "name": "(4)HFZ",
    "points": [
      [
        -71.76676361367298,
        19.736702040417352
      ],
      [
        -71.6975482859382,
        19.69900103192446
      ],
      [
        -71.61574835316073,
        19.655914165075444
      ],
      [
        -71.55282532794728,
        19.623599014938677
      ],
      [
        -71.4710253951698,
        19.585898006445788
      ],
      [
        -71.39866391617434,
        19.55896871466515
      ],
      [
        -71.31057168087553,
        19.521267706172257
      ],
      [
        -71.22562559683738,
        19.49972427274775
      ],
      [
        -71.13124105901721,
        19.467409122610984
      ],
      [
        -71.0305642186757,
        19.44047983083035
      ],
      [
        -70.90471816824882,
        19.41355053904971
      ],
      [
        -70.76628751277924,
        19.37584953055682
      ],
      [
        -70.624710706049,
        19.3327626637078
      ],
      [
        -70.52088771444681,
        19.305833371927164
      ],
      [
        -70.42021087410531,
        19.284289938502653
      ],
      [
        -70.29436482367844,
        19.24658893000976
      ],
      [
        -70.17795722703356,
        19.23581721329751
      ],
      [
        -70.01750351273928,
        19.225045496585253
      ],
      [
        -69.87278055474836,
        19.20888792151687
      ],
      [
        -69.7783960169282,
        19.198116204804613
      ],
      [
        -69.69974223541139,
        19.19273034644849
      ],
      [
        -69.63996536145862,
        19.181958629736233
      ],
      [
        -69.64625766397997,
        19.111942471106577
      ],
      [
        -69.69030378162938,
        19.095784896038193
      ],
      [
        -69.7563729581035,
        19.10655661275045
      ],
      [
        -69.80356522701358,
        19.10655661275045
      ],
      [
        -69.88851131105173,
        19.117328329462705
      ],
      [
        -69.95143433626517,
        19.128100046174957
      ],
      [
        -70.02379581526063,
        19.122714187818833
      ],
      [
        -70.10244959677743,
        19.128100046174957
      ],
      [
        -70.2062725883796,
        19.128100046174957
      ],
      [
        -70.31324173124246,
        19.14964347959947
      ],
      [
        -70.37301860519523,
        19.16580105466785
      ],
      [
        -70.432795479148,
        19.181958629736233
      ],
      [
        -70.41391857158396,
        19.14425762124334
      ],
      [
        -70.40448011780195,
        19.10117075439432
      ],
      [
        -70.39818781528061,
        19.04192631247692
      ],
      [
        -70.40133396654129,
        18.9988394456279
      ],
      [
        -70.40762626906263,
        18.934209145354373
      ],
      [
        -70.42021087410531,
        18.885736420149225
      ],
      [
        -70.44223393293002,
        18.842649553300205
      ],
      [
        -70.47369544553673,
        18.81033440316344
      ],
      [
        -70.5020108068828,
        18.77263339467055
      ],
      [
        -70.51774156318615,
        18.745704102889913
      ],
      [
        -70.59010304218161,
        18.79956268645119
      ],
      [
        -70.56178768083556,
        18.848035411656333
      ],
      [
        -70.5240338657075,
        18.891122278505353
      ],
      [
        -70.49886465562211,
        18.9395950037105
      ],
      [
        -70.4894262018401,
        19.009611162340157
      ],
      [
        -70.4894262018401,
        19.079627320969813
      ],
      [
        -70.50515695814346,
        19.133485904531085
      ],
      [
        -70.5460569245322,
        19.18734448809236
      ],
      [
        -70.60583379848497,
        19.219659638229125
      ],
      [
        -70.66561067243774,
        19.241203071653633
      ],
      [
        -70.7599952102579,
        19.273518221790397
      ],
      [
        -70.83550284051404,
        19.28967579685878
      ],
      [
        -70.9298873783342,
        19.316605088639417
      ],
      [
        -71.02741806741503,
        19.33814852206393
      ],
      [
        -71.13124105901721,
        19.370463672200692
      ],
      [
        -71.25079480692276,
        19.408164680693584
      ],
      [
        -71.34517934474292,
        19.429708114118093
      ],
      [
        -71.4490023363451,
        19.472794980967112
      ],
      [
        -71.53080226912257,
        19.505110131103876
      ],
      [
        -71.60945605063938,
        19.53742528124064
      ],
      [
        -71.68181752963484,
        19.58051214808966
      ],
      [
        -71.72586364728424,
        19.60205558151417
      ],
      [
        -71.74788670610896,
        19.623599014938677
      ],
      [
        -71.76676361367298,
        19.736702040417352
      ]
    ]
  },
  {
    "name": "(9)LPSJFZ",
    "points": [
      [
        -71.65350216828878,
        19.171186913023977
      ],
      [
        -71.5622637817293,
        19.14964347959947
      ],
      [
        -71.53080226912257,
        19.16580105466785
      ],
      [
        -71.47731769769115,
        19.16580105466785
      ],
      [
        -71.42383312625972,
        19.16580105466785
      ],
      [
        -71.37349470608896,
        19.155029337955597
      ],
      [
        -71.33888704222157,
        19.14425762124334
      ],
      [
        -71.29798707583284,
        19.111942471106577
      ],
      [
        -71.26652556322611,
        19.08501317932594
      ],
      [
        -71.24764865566209,
        19.04192631247692
      ],
      [
        -71.20360253801267,
        19.009611162340157
      ],
      [
        -71.15011796658125,
        18.971910153847265
      ],
      [
        -71.09663339514982,
        18.928823286998245
      ],
      [
        -71.0651718825431,
        18.91266571192986
      ],
      [
        -71.008541159851,
        18.907279853573737
      ],
      [
        -70.93932583211621,
        18.874964703436973
      ],
      [
        -70.88269510942412,
        18.842649553300205
      ],
      [
        -70.81347978168932,
        18.79417682809506
      ],
      [
        -70.74426445395454,
        18.740318244533785
      ],
      [
        -70.67190297495908,
        18.686459660972513
      ],
      [
        -70.59639534470296,
        18.632601077411238
      ],
      [
        -70.52718001696816,
        18.58951421056222
      ],
      [
        -70.46111084049406,
        18.530269768644818
      ],
      [
        -70.41706472284464,
        18.46563946837129
      ],
      [
        -70.36358015141322,
        18.395623309741634
      ],
      [
        -70.32582633628515,
        18.336378867824234
      ],
      [
        -70.2975109749391,
        18.30406371768747
      ],
      [
        -70.26919561359306,
        18.266362709194578
      ],
      [
        -70.25975715981103,
        18.244819275770066
      ],
      [
        -70.30065712619978,
        18.239433417413938
      ],
      [
        -70.33526479006717,
        18.234047559057814
      ],
      [
        -70.37301860519523,
        18.244819275770066
      ],
      [
        -70.41391857158396,
        18.29867785933134
      ],
      [
        -70.46740314301539,
        18.384851593029378
      ],
      [
        -70.50830310940414,
        18.44948189330291
      ],
      [
        -70.58695689092093,
        18.50872633522031
      ],
      [
        -70.66875682369842,
        18.557199060425454
      ],
      [
        -70.7379721514332,
        18.616443502342857
      ],
      [
        -70.80089517664663,
        18.67030208590413
      ],
      [
        -70.97707964724428,
        18.778019253026677
      ],
      [
        -71.05887958002175,
        18.81033440316344
      ],
      [
        -71.09977954641049,
        18.826491978231825
      ],
      [
        -71.1658487228846,
        18.85880712836859
      ],
      [
        -71.26023326070477,
        18.934209145354373
      ],
      [
        -71.32315628591822,
        19.00422530398403
      ],
      [
        -71.37978700861031,
        19.0580838875453
      ],
      [
        -71.4615869413878,
        19.068855604257557
      ],
      [
        -71.52450996660123,
        19.068855604257557
      ],
      [
        -71.57799453803266,
        19.068855604257557
      ],
      [
        -71.63462526072476,
        19.074241462613685
      ],
      [
        -71.68810983215619,
        19.08501317932594
      ],
      [
        -71.71642519350223,
        19.095784896038193
      ],
      [
        -71.71327904224155,
        19.128100046174957
      ],
      [
        -71.66608677333147,
        19.138871762887213
      ],
      [
        -71.65350216828878,
        19.171186913023977
      ]
    ]
  },
  {
    "name": "(13)HIGFZ",
    "points": [
      [
        -68.8188198824232,
        19.009611162340157
      ],
      [
        -68.78421221855581,
        18.923437428642117
      ],
      [
        -68.75275070594908,
        18.85342127001246
      ],
      [
        -68.74960455468842,
        18.821106119875697
      ],
      [
        -68.74331225216707,
        18.761861677958297
      ],
      [
        -68.72443534460304,
        18.724160669465405
      ],
      [
        -68.68982768073565,
        18.64875865247962
      ],
      [
        -68.66465847065027,
        18.58951421056222
      ],
      [
        -68.64578156308623,
        18.497954618508054
      ],
      [
        -68.63634310930422,
        18.454867751659034
      ],
      [
        -68.61117389921884,
        18.42255260152227
      ],
      [
        -68.5828585378728,
        18.395623309741634
      ],
      [
        -68.5608354790481,
        18.374079876317126
      ],
      [
        -68.5922969916548,
        18.374079876317126
      ],
      [
        -68.61432005047952,
        18.368694017960998
      ],
      [
        -68.60802774795818,
        18.34176472618036
      ],
      [
        -68.6269046555222,
        18.314835434399722
      ],
      [
        -68.66780462191095,
        18.34176472618036
      ],
      [
        -68.69926613451766,
        18.379465734673254
      ],
      [
        -68.72758149586372,
        18.438710176590654
      ],
      [
        -68.75904300847043,
        18.573356635493838
      ],
      [
        -68.80308912611984,
        18.664916227548005
      ],
      [
        -68.82511218494454,
        18.71338895275315
      ],
      [
        -68.83140448746589,
        18.79956268645119
      ],
      [
        -68.85971984881193,
        18.864192986724717
      ],
      [
        -68.88488905889731,
        18.91805157028599
      ],
      [
        -68.90691211772202,
        18.971910153847265
      ],
      [
        -68.9320813278074,
        19.036540454120793
      ],
      [
        -68.8188198824232,
        19.009611162340157
      ]
    ]
  },
  {
    "name": "(12)SJMFZ",
    "points": [
      [
        -71.776202067455,
        18.928823286998245
      ],
      [
        -71.70069443719886,
        18.923437428642117
      ],
      [
        -71.62204065568207,
        18.891122278505353
      ],
      [
        -71.55282532794728,
        18.880350561793097
      ],
      [
        -71.46787924390914,
        18.85880712836859
      ],
      [
        -71.39551776491368,
        18.842649553300205
      ],
      [
        -71.3357408909609,
        18.826491978231825
      ],
      [
        -71.28540247079015,
        18.79956268645119
      ],
      [
        -71.21933329431603,
        18.767247536314425
      ],
      [
        -71.1564102691026,
        18.740318244533785
      ],
      [
        -71.08090263884645,
        18.718774811109277
      ],
      [
        -71.02741806741503,
        18.69723137768477
      ],
      [
        -70.95820273968025,
        18.681073802616385
      ],
      [
        -70.91730277329151,
        18.664916227548005
      ],
      [
        -70.85752589933874,
        18.637986935767366
      ],
      [
        -70.79774902538597,
        18.6056717856306
      ],
      [
        -70.74426445395454,
        18.578742493849965
      ],
      [
        -70.69707218504446,
        18.55181320206933
      ],
      [
        -70.6467337648737,
        18.514112193576437
      ],
      [
        -70.61212610100631,
        18.487182901795798
      ],
      [
        -70.5806645883996,
        18.44409603494678
      ],
      [
        -70.59639534470296,
        18.42255260152227
      ],
      [
        -70.63729531109169,
        18.438710176590654
      ],
      [
        -70.67190297495908,
        18.438710176590654
      ],
      [
        -70.70021833630513,
        18.438710176590654
      ],
      [
        -70.77257981530059,
        18.481797043439673
      ],
      [
        -70.82291823547135,
        18.50872633522031
      ],
      [
        -70.9078643195095,
        18.5464273437132
      ],
      [
        -70.98022579850495,
        18.573356635493838
      ],
      [
        -71.06202573128243,
        18.600285927274474
      ],
      [
        -71.12494875649587,
        18.62721521905511
      ],
      [
        -71.200456386752,
        18.659530369191877
      ],
      [
        -71.26967171448679,
        18.69184551932864
      ],
      [
        -71.34203319348225,
        18.718774811109277
      ],
      [
        -71.40810236995637,
        18.75108996124604
      ],
      [
        -71.48675615147316,
        18.77263339467055
      ],
      [
        -71.57484838677199,
        18.778019253026677
      ],
      [
        -71.63462526072476,
        18.79956268645119
      ],
      [
        -71.6975482859382,
        18.821106119875697
      ],
      [
        -71.73215594980559,
        18.826491978231825
      ],
      [
        -71.73530210106627,
        18.874964703436973
      ],
      [
        -71.74788670610896,
        18.90189399521761
      ],
      [
        -71.776202067455,
        18.928823286998245
      ]
    ]
  },
  {
    "name": "(11)EPGEZ",
    "points": [
      [
        -72.01845571452675,
        18.632601077411238
      ],
      [
        -71.98384805065936,
        18.67030208590413
      ],
      [
        -71.93036347922794,
        18.659530369191877
      ],
      [
        -71.87373275653583,
        18.64875865247962
      ],
      [
        -71.7982251262797,
        18.62721521905511
      ],
      [
        -71.70384058845954,
        18.621829360698985
      ],
      [
        -71.6629406220708,
        18.621829360698985
      ],
      [
        -71.60001759685736,
        18.600285927274474
      ],
      [
        -71.53080226912257,
        18.573356635493838
      ],
      [
        -71.45214848760577,
        18.535655627000946
      ],
      [
        -71.37664085734964,
        18.50872633522031
      ],
      [
        -71.32944858843956,
        18.50334047686418
      ],
      [
        -71.27281786574746,
        18.476411185083546
      ],
      [
        -71.20360253801267,
        18.433324318234526
      ],
      [
        -71.13753336153856,
        18.40639502645389
      ],
      [
        -71.05887958002175,
        18.379465734673254
      ],
      [
        -70.98337194976563,
        18.352536442892614
      ],
      [
        -70.93932583211621,
        18.336378867824234
      ],
      [
        -70.8732566556421,
        18.32022129275585
      ],
      [
        -70.90157201698815,
        18.287906142619086
      ],
      [
        -70.95505658841958,
        18.255590992482322
      ],
      [
        -70.99595655480832,
        18.282520284262958
      ],
      [
        -71.02741806741503,
        18.32022129275585
      ],
      [
        -71.0651718825431,
        18.32022129275585
      ],
      [
        -71.09663339514982,
        18.29867785933134
      ],
      [
        -71.11236415145318,
        18.26097685083845
      ],
      [
        -71.09348724388914,
        18.223275842345558
      ],
      [
        -71.07775648758579,
        18.185574833852666
      ],
      [
        -71.06831803380378,
        18.153259683715902
      ],
      [
        -71.06831803380378,
        18.137102108647518
      ],
      [
        -71.13753336153856,
        18.153259683715902
      ],
      [
        -71.2350640506194,
        18.164031400428158
      ],
      [
        -71.30113322709352,
        18.185574833852666
      ],
      [
        -71.36091010104627,
        18.207118267277174
      ],
      [
        -71.54338687416526,
        18.330993009468106
      ],
      [
        -71.63777141198543,
        18.336378867824234
      ],
      [
        -71.71327904224155,
        18.357922301248742
      ],
      [
        -71.8108097313224,
        18.390237451385506
      ],
      [
        -71.86114815149315,
        18.44409603494678
      ],
      [
        -71.9114865716639,
        18.46563946837129
      ],
      [
        -71.91463272292458,
        18.487182901795798
      ],
      [
        -71.8894635128392,
        18.50872633522031
      ],
      [
        -71.95238653805264,
        18.573356635493838
      ],
      [
        -72.01845571452675,
        18.632601077411238
      ]
    ]
  }
  // Pegar aqui el contenido del JSON
];

const mapContainerStyle = {
  width: '100%',
  height: '100%'
};

const defaultCenter = {
  lat: 19.0,
  lng: -70.6
};

const mapOptions = {
  mapTypeId: 'terrain',
  mapTypeControl: true,
  scaleControl: true,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: true,
  zoomControl: true,
  styles: [
    {
      featureType: 'all',
      elementType: 'geometry',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#87CEEB' }]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#F5F5F5' }]
    }
  ]
};

// Funcion para verificar si un punto esta dentro de un poligono
const isPointInPolygon = (point, polygon) => {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0], yi = polygon[i][1];
    const xj = polygon[j][0], yj = polygon[j][1];
    
    const intersect = ((yi > point[1]) !== (yj > point[1]))
        && (point[0] < (xj - xi) * (point[1] - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
};

// Funcion para verificar coordenadas
const checkNearField = (lon, lat) => {
  if (!lon || !lat) return { isNearField: false, areaName: null };
  
  for (const area of areasDefinidas) {
    if (isPointInPolygon([lon, lat], area.points)) {
      return {
        isNearField: true,
        areaName: area.name
      };
    }
  }
  return {
    isNearField: false,
    areaName: null
  };
};

const generatePDF = async (results, params, nearFieldStatus, chartRef) => {
  try {
    const doc = new jsPDF();
    
    // Funcion para anadir marca de agua con el logo
    const addWatermark = async (doc) => {
      try {
        // 1. Cargar la imagen del logo
        const logoImage = await new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = '/images/SismoStructRD.png'; // Asegurate que esta ruta sea correcta (o usa logo.png)
        });
        
        // 2. Crear un canvas para manipular la imagen
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = logoImage.width;
        canvas.height = logoImage.height;
        
        // 3. Dibujar la imagen con transparencia
        ctx.globalAlpha = 0.1; // Opacidad al 10%
        ctx.drawImage(logoImage, 0, 0);
        
        // 4. Convertir a imagen para jsPDF
        const logoDataUrl = canvas.toDataURL('image/png');
        
        // 5. Anadir como marca de agua (centrada)
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const logoWidth = 100; // Ancho deseado
        const logoHeight = (logoImage.height * logoWidth) / logoImage.width;
        
        doc.addImage(
          logoDataUrl, 
          'PNG', 
          (pageWidth - logoWidth) / 2, 
          (pageHeight - logoHeight) / 2, 
          logoWidth, 
          logoHeight
        );
        
        return logoDataUrl; // Devolver la URL de la imagen para usarla en la ultima pagina
      } catch (error) {
        console.error('Error al anadir marca de agua:', error);
        return null;
      }
    };
    
    // Anadir marca de agua solo en la primera pagina
    const logoDataUrl = await addWatermark(doc);
    
    let yPos = 20;

    // Titulo
    doc.setFontSize(16);
    doc.text('Analisis Sismico - Resultados', 105, yPos, { align: 'center' });

    // Informacion basica
    doc.setFontSize(12);
    yPos += 10;
    doc.text('Informacion del Proyecto:', 20, yPos);
    yPos += 5;
    doc.setFontSize(10);
    doc.text(`Descripcion: ${params.descripcion || 'No especificada'}`, 25, yPos);
    yPos += 5;
    doc.text(`Ubicacion: (${params.lat}, ${params.lng})`, 25, yPos);
    yPos += 5;
    doc.text(`Ubicacion en la falla: ${nearFieldStatus?.isNearField ? 
      `Dentro de Campo Cercano Falla ${nearFieldStatus.areaName}` : 'Fuera de campo cercano'}`, 25, yPos);
    
    // Agregar valores de Ss y S1
    yPos += 5;
    doc.text(`Ss = ${results.ss.toFixed(3)}`, 25, yPos);
    yPos += 5;
    doc.text(`S1 = ${results.s1.toFixed(3)}`, 25, yPos);

    // Parametros de entrada
    yPos += 7;
    doc.setFontSize(12);
    doc.text('Parametros de Entrada:', 20, yPos);
    yPos += 5;
    doc.setFontSize(10);
    
    // Array para parametros de entrada
    const entryParams = [
      `Tipo de Suelo: ${params.tipoSuelo}`,
      `Categoria de Riesgo: ${params.categoriaRiesgo}`,
      `Sistema Estructural: ${params.sistemaEstructural}`,
      `Altura: ${params.altura} m`,
      `CDS: ${results.cds}`,
      `Factor de Redundancia (rho): ${results.rho?.toFixed(1)}`,
      `Cs: ${results.cs?.toFixed(4)}`,
    ];

    
    doc.text(entryParams, 25, yPos);
    yPos += 5;
    // Resultados - ajustamos el espaciado vertical en funcion de los parametros
    const paramSpacing = entryParams.length > 6 ? entryParams.length * 4 : 28;
    yPos += paramSpacing;
    
    doc.setFontSize(12);
    doc.text('Resultados del Analisis:', 20, yPos);
    yPos += 5;
    doc.setFontSize(10);

    // Primera columna
    let xPos = 25;
    doc.text([
      'Parametros Espectrales:',
      `SDS = ${results.sds.toFixed(3)}`,
      `SD1 = ${results.sd1.toFixed(3)}`,
      `T0 = ${results.t0.toFixed(3)} s`,
      `Ts = ${results.ts.toFixed(3)} s`
    ], xPos, yPos);

    // Segunda columna
    xPos = 110;
    doc.text([
      'Factores CDCRD 2026:',
      `Fa = ${results.fa?.toFixed(3) ?? '-'}`,
      `Fv = ${results.fv?.toFixed(3) ?? '-'}`,
      `R = ${results.R ?? '-'}`,
      `Ie = ${results.Ie?.toFixed(2) ?? '-'}`
    ], xPos, yPos);

    // Coeficiente sismico
    yPos += 25;
    doc.text([
      'Coeficiente Sismico de Diseno (CDCRD 2026):',
      `Cs = ${results.cs?.toFixed(4) ?? '-'}`,
      `Cs,min = ${results.cs_min?.toFixed(4) ?? '-'}`,
      `CDS = ${results.cds ?? '-'}`,
      `Factor de Redundancia (rho) = ${results.rho?.toFixed(1) ?? '-'}`,
    ], 25, yPos);

    // Combinaciones de carga CDCRD 2026
    yPos += 30;
    doc.setFontSize(12);
    doc.text('Combinaciones de Carga Sismicas (CDCRD 2026):', 20, yPos);
    yPos += 5;
    doc.setFontSize(10);

    const ev   = 0.2 * results.sds;
    const c3c4 = (1.2 + ev).toFixed(3);
    const c5c6 = (0.9 - ev).toFixed(3);
    xPos = 25;
    doc.text([
      'C1 = 1.4CM',
      'C2 = 1.2CM + 1.6CV',
      `C3 = ${c3c4}CM + CV + QEx`,
    ], xPos, yPos);

    xPos = 110;
    doc.text([
      `C4 = ${c3c4}CM + CV + QEy`,
      `C5 = ${c5c6}CM + QEx`,
      `C6 = ${c5c6}CM + QEy`,
    ], xPos, yPos);

    yPos += 15;
    doc.text('CM=Carga Muerta, CV=Carga Viva, QE=Fuerza sismica horizontal (incluye rho)', 25, yPos, { maxWidth: 160 });
    yPos += 5;
    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);
    doc.text(`Ev = 0.2 x SDS = 0.2 x ${results.sds?.toFixed(3)} = ${ev.toFixed(3)}  (CDCRD 2026 Sec. F.2.12)`, 25, yPos);
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);

    // Espectro en pagina propia para que tenga espacio completo
    doc.addPage();
    yPos = 20;
    doc.setFontSize(14);
    doc.text('Espectro de Diseno (CDCRD 2026)', 105, yPos, { align: 'center' });
    yPos += 8;

    if (chartRef.current) {
      const chartContainer = chartRef.current;

      // Expandir temporalmente para mejor captura
      const origHeight = chartContainer.style.height;
      chartContainer.style.height = '320px';

      const canvas = await html2canvas(chartContainer, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
      });

      chartContainer.style.height = origHeight;

      const imgData = canvas.toDataURL('image/png', 1.0);

      // 170mm de ancho, centrado en A4 (x=20), con altura proporcional
      const imgWidth  = 170;
      const rawHeight = (canvas.height * imgWidth) / canvas.width;
      const imgHeight = Math.min(rawHeight, 110); // max 110mm
      doc.addImage(imgData, 'PNG', 20, yPos, imgWidth, imgHeight);

      // Leyenda manual debajo del grafico
      yPos += imgHeight + 6;
      doc.setFontSize(9);

      doc.setDrawColor(59, 130, 246);
      doc.setLineWidth(1.0);
      doc.line(25, yPos, 40, yPos);
      doc.setTextColor(0, 0, 0);
      doc.text('Sa Elastico de Diseno (g)  [Sec. 2.9.4.5 CDCRD 2026]', 43, yPos + 1);

      yPos += 6;
      doc.setDrawColor(249, 115, 22);
      doc.setLineWidth(1.0);
      for (let lx = 25; lx <= 38; lx += 4) doc.line(lx, yPos, lx + 2, yPos);
      doc.setTextColor(0, 0, 0);
      doc.text('Sa Inelastico (g)  =  Sa x Ie/R x rho', 43, yPos + 1);

      doc.setLineWidth(0.2);
      doc.setDrawColor(0, 0, 0);
      doc.setFontSize(10);
    }
    
    // Anadir nueva pagina para el primer mapa de isoaceleraciones (Ss)
    doc.addPage();
    
    // No anadir marca de agua en esta pagina
    
    yPos = 20;
    
    // Titulo del primer mapa
    doc.setFontSize(14);
    doc.text('Mapa-6.- Mapa de Isoaceleraciones espectrales Ss, para un 2% ', 105, yPos, { align: 'center' });
    yPos += 5;
    doc.text('de Probabilidad de ser excedida en 50 anos', 105, yPos, { align: 'center' });
    yPos += 10;
    
    try {
      // Cargar la imagen del primer mapa (Ss)
      const mapImage1 = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        // Asegurate de que la ruta sea correcta
        img.src = '/images/mapa_isoaceleraciones-ss.png'; 
      });
      
      // Calcular dimensiones para mantener la proporcion
      const mapWidth = 170;
      const mapHeight = (mapImage1.height * mapWidth) / mapImage1.width;
      
      // Crear un canvas para manipular la imagen
      const canvas1 = document.createElement('canvas');
      canvas1.width = mapImage1.width;
      canvas1.height = mapImage1.height;
      const ctx1 = canvas1.getContext('2d');
      ctx1.drawImage(mapImage1, 0, 0);
      
      // Definir los limites geograficos del mapa
      const mapBounds = {
        minLon: -74.5,
        maxLon: -67,
        minLat: 17,
        maxLat: 20.5280
      };
      
      // Convertir coordenadas geograficas a coordenadas de imagen
      const xRatio = mapImage1.width / (mapBounds.maxLon - mapBounds.minLon);
      const yRatio = mapImage1.height / (mapBounds.maxLat - mapBounds.minLat);
      
      const pixelX = (params.lng - mapBounds.minLon) * xRatio;
      const pixelY = mapImage1.height - (params.lat - mapBounds.minLat) * yRatio;
      
      // Dibujar marcador en la ubicacion del proyecto
      ctx1.fillStyle = 'red';
      ctx1.beginPath();
      ctx1.arc(pixelX, pixelY, 5, 0, 2 * Math.PI);
      ctx1.fill();
      
      // Dibujar flecha apuntando a la ubicacion
      ctx1.strokeStyle = 'red';
      ctx1.lineWidth = 3;
      ctx1.beginPath();
      ctx1.moveTo(pixelX - 20, pixelY - 20);
      ctx1.lineTo(pixelX, pixelY);
      ctx1.stroke();
      
      // Convertir a base64
      const mapDataUrl1 = canvas1.toDataURL('image/png');
      
      // Anadir imagen al PDF
      doc.addImage(mapDataUrl1, 'PNG', 20, yPos, mapWidth, mapHeight);
      
      // Anadir leyenda explicativa
      yPos += mapHeight + 10;
      doc.setFontSize(10);
      doc.text('Mapa de isoaceleraciones espectral de referencia para periodos cortos (T=0.20 seg). Fuente MIVHED, CDCRD 2026.', 20, yPos, { maxWidth: 170 });
      yPos += 5;
      doc.text('El punto rojo indica la ubicacion del proyecto para el cual se realizo el analisis sismico.', 20, yPos, { maxWidth: 170 });
      
    } catch (error) {
      console.error('Error al cargar o procesar el primer mapa:', error);
      doc.setFontSize(10);
      doc.text('No se pudo cargar el mapa de isoaceleraciones Ss. Verifique que la imagen existe en la ruta correcta.', 20, yPos);
    }
    
    // Mapa S1 en pagina propia
    doc.addPage();
    yPos = 20;
    
    // Titulo del segundo mapa
    doc.setFontSize(14);
    doc.text('Mapa-7.- Mapa de Isoaceleraciones espectrales S1, para un 2% ', 105, yPos, { align: 'center' });
    yPos += 5;
    doc.text('de Probabilidad de ser excedida en 50 anos', 105, yPos, { align: 'center' });
    yPos += 10;
    
    try {
      // Cargar la imagen del segundo mapa (S1)
      const mapImage2 = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        // Asegurate de que la ruta sea correcta
        img.src = '/images/mapa_isoaceleraciones-s1.png'; 
      });
      
      // Calcular dimensiones para mantener la proporcion
      const mapWidth = 170;
      const mapHeight = (mapImage2.height * mapWidth) / mapImage2.width;
      
      // Crear un canvas para manipular la imagen
      const canvas2 = document.createElement('canvas');
      canvas2.width = mapImage2.width;
      canvas2.height = mapImage2.height;
      const ctx2 = canvas2.getContext('2d');
      ctx2.drawImage(mapImage2, 0, 0);
      
      // Definir los limites geograficos del mapa
      const mapBounds = {
        minLon: -74.5,
        maxLon: -67,
        minLat: 17,
        maxLat: 20.5280
      };
      
      // Convertir coordenadas geograficas a coordenadas de imagen
      const xRatio = mapImage2.width / (mapBounds.maxLon - mapBounds.minLon);
      const yRatio = mapImage2.height / (mapBounds.maxLat - mapBounds.minLat);
      
      const pixelX = (params.lng - mapBounds.minLon) * xRatio;
      const pixelY = mapImage2.height - (params.lat - mapBounds.minLat) * yRatio;
      
      // Dibujar marcador en la ubicacion del proyecto
      ctx2.fillStyle = 'red';
      ctx2.beginPath();
      ctx2.arc(pixelX, pixelY, 5, 0, 2 * Math.PI);
      ctx2.fill();
      
      // Dibujar flecha apuntando a la ubicacion
      ctx2.strokeStyle = 'red';
      ctx2.lineWidth = 3;
      ctx2.beginPath();
      ctx2.moveTo(pixelX - 20, pixelY - 20);
      ctx2.lineTo(pixelX, pixelY);
      ctx2.stroke();
      
      // Convertir a base64
      const mapDataUrl2 = canvas2.toDataURL('image/png');
      
      // Anadir imagen al PDF
      doc.addImage(mapDataUrl2, 'PNG', 20, yPos, mapWidth, mapHeight);
      
      // Anadir leyenda explicativa
      yPos += mapHeight + 10;
      doc.setFontSize(10);
      doc.text('Mapa de isoaceleraciones espectral de referencia para periodos largos (T=1.00 seg). Fuente MIVHED, CDCRD 2026.', 20, yPos, { maxWidth: 170 });
      yPos += 5;
      doc.text('El punto rojo indica la ubicacion del proyecto para el cual se realizo el analisis sismico.', 20, yPos, { maxWidth: 170 });
      
    } catch (error) {
      console.error('Error al cargar o procesar el segundo mapa:', error);
      doc.setFontSize(10);
      doc.text('No se pudo cargar el mapa de isoaceleraciones S1. Verifique que la imagen existe en la ruta correcta.', 20, yPos);
    }
    
    // Anadir nueva pagina para el mapa de campo cercano
    doc.addPage();
    
    // Anadir marca de agua solo en la ultima pagina (tercera pagina)
    if (logoDataUrl) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const logoWidth = 100;
      const logoHeight = 100 * 0.75; // Estimacion aproximada si no tenemos las dimensiones reales
      
      doc.addImage(
        logoDataUrl,
        'PNG',
        (pageWidth - logoWidth) / 2,
        (pageHeight - logoHeight) / 2,
        logoWidth,
        logoHeight
      );
    }
    
    yPos = 20;
    
    // Titulo del mapa de campo cercano
    doc.setFontSize(14);
    doc.text('Mapa-11.- Mapa del Campo Cercano', 105, yPos, { align: 'center' });
    yPos += 10;
    
    try {
      // Cargar la imagen del mapa de campo cercano
      const mapImage3 = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        // Asegurate de que la ruta sea correcta
        img.src = '/images/mapa_campo_cercano.png'; 
      });
      
      // Calcular dimensiones para mantener la proporcion
      const mapWidth = 170;
      const mapHeight = (mapImage3.height * mapWidth) / mapImage3.width;
      
      // Crear un canvas para manipular la imagen
      const canvas3 = document.createElement('canvas');
      canvas3.width = mapImage3.width;
      canvas3.height = mapImage3.height;
      const ctx3 = canvas3.getContext('2d');
      ctx3.drawImage(mapImage3, 0, 0);
      
      // Definir los limites geograficos del mapa
      const mapBounds = {
        minLon: -74.5,
        maxLon: -67,
        minLat: 17,
        maxLat: 20.5280
      };
      
      // Convertir coordenadas geograficas a coordenadas de imagen
      const xRatio = mapImage3.width / (mapBounds.maxLon - mapBounds.minLon);
      const yRatio = mapImage3.height / (mapBounds.maxLat - mapBounds.minLat);
      
      const pixelX = (params.lng - mapBounds.minLon) * xRatio;
      const pixelY = mapImage3.height - (params.lat - mapBounds.minLat) * yRatio;
      
      // Dibujar marcador en la ubicacion del proyecto
      ctx3.fillStyle = 'red';
      ctx3.beginPath();
      ctx3.arc(pixelX, pixelY, 5, 0, 2 * Math.PI);
      ctx3.fill();
      
      // Dibujar flecha apuntando a la ubicacion
      ctx3.strokeStyle = 'red';
      ctx3.lineWidth = 3;
      ctx3.beginPath();
      ctx3.moveTo(pixelX - 20, pixelY - 20);
      ctx3.lineTo(pixelX, pixelY);
      ctx3.stroke();
      
      // Convertir a base64
      const mapDataUrl3 = canvas3.toDataURL('image/png');
      
      // Anadir imagen al PDF
      doc.addImage(mapDataUrl3, 'PNG', 20, yPos, mapWidth, mapHeight);
      
      // Anadir leyenda explicativa
      yPos += mapHeight + 10;
      doc.setFontSize(10);
      doc.text('Mapa de fallas activas y zonas de campo cercano a la falla. Fuente MIVHED, CDCRD 2026.', 20, yPos, { maxWidth: 170 });
      yPos += 5;
      doc.text('El punto rojo indica la ubicacion del proyecto para el cual se realizo el analisis sismico.', 20, yPos, { maxWidth: 170 });
      
      // Anadir informacion sobre la ubicacion del proyecto en relacion a las fallas
      yPos += 10;
      doc.setFontSize(11);
      
      // Condicional para el color del texto segun el estado de campo cercano
      if (nearFieldStatus?.isNearField) {
        // Si esta dentro del campo cercano, texto en rojo
        doc.setTextColor(255, 0, 0);
        doc.text(`Estado: Proyecto dentro de Campo Cercano - Falla ${nearFieldStatus.areaName}`, 20, yPos);
      } else {
        // Si esta fuera del campo cercano, texto en verde
        doc.setTextColor(0, 128, 0);
        doc.text("Estado: Proyecto fuera de Campo Cercano", 20, yPos);
      }
      
      // Volver a color negro para el resto del documento
      doc.setTextColor(0, 0, 0);
      
    } catch (error) {
      console.error('Error al cargar o procesar el mapa de campo cercano:', error);
      doc.setFontSize(10);
      doc.text('No se pudo cargar el mapa de campo cercano. Verifique que la imagen existe en la ruta correcta.', 20, yPos);
    }
    
    // Guardar el PDF
    doc.save('analisis-sismico.pdf');
  } catch (error) {
    console.error('Error al generar el PDF:', error);
    alert('Error al generar el PDF. Por favor, intente nuevamente.');
  }
};

const SeismicMap = () => {
  const [marker, setMarker] = useState(null);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [mapAuthError, setMapAuthError] = useState(false);
  const [params, setParams] = useState({
    descripcion: '',
    tipoSuelo: 'D',
    categoriaRiesgo: 'II',
    sistemaEstructural: 'Porticos especiales de hormigon armado',
    altura: 12.0,
    irregularidades: {
      pisoSuave:              false,
      pisoDebil:              false,
      masaIrregular:          false,
      discontinuidadSistema:  false,
      irregularidadTorsional: false,
      reentrantesEnPlanta:    false,
      discontinuidadDiafragma: false,
      sistemasNoParalelos:    false,
    },
  });
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [nearFieldStatus, setNearFieldStatus] = useState(null);
  const chartRef = useRef(null);
  const mapRef = useRef(null);
  // Anadir despues de todos los useState y antes del resetMap
// Funcion para guardar datos en localStorage
const saveDataToLocalStorage = useCallback(() => {
  if (marker && lat && lng) {
    localStorage.setItem('seismic_marker', JSON.stringify(marker));
    localStorage.setItem('seismic_lat', lat);
    localStorage.setItem('seismic_lng', lng);
    localStorage.setItem('seismic_params', JSON.stringify(params));
    if (results) localStorage.setItem('seismic_results', JSON.stringify(results));
    if (nearFieldStatus) localStorage.setItem('seismic_nearFieldStatus', JSON.stringify(nearFieldStatus));
  }
}, [marker, lat, lng, params, results, nearFieldStatus]);

// Funcion para cargar datos de localStorage
const loadDataFromLocalStorage = useCallback(() => {
  try {
    const savedMarker = localStorage.getItem('seismic_marker');
    const savedLat = localStorage.getItem('seismic_lat');
    const savedLng = localStorage.getItem('seismic_lng');
    const savedParams = localStorage.getItem('seismic_params');
    const savedResults = localStorage.getItem('seismic_results');
    const savedNearFieldStatus = localStorage.getItem('seismic_nearFieldStatus');

    if (savedMarker) setMarker(JSON.parse(savedMarker));
    if (savedLat) setLat(savedLat);
    if (savedLng) setLng(savedLng);
    if (savedParams) setParams(JSON.parse(savedParams));
    if (savedResults) {
      const parsed = JSON.parse(savedResults);
      // Descartar resultados viejos que no tienen saMCE (incompatibles con version actual)
      if (parsed?.espectro?.saMCE) setResults(parsed);
      else localStorage.removeItem('seismic_results');
    }
    if (savedNearFieldStatus) setNearFieldStatus(JSON.parse(savedNearFieldStatus));
  } catch (error) {
    console.error('Error cargando datos guardados:', error);
  }
}, []);

// Cargar datos al iniciar
useEffect(() => {
  loadDataFromLocalStorage();
}, [loadDataFromLocalStorage]);

// Guardar datos cuando cambien
useEffect(() => {
  saveDataToLocalStorage();
}, [marker, lat, lng, params, results, nearFieldStatus, saveDataToLocalStorage]);

  // Funcion para resetear el mapa y todos los estados 
  // eslint-disable-next-line no-unused-vars
  const resetMap = useCallback(() => {
    setMarker(null);
    setLat('');
    setLng('');
    setResults(null);
    setError(null);
    setNearFieldStatus(null);
    // resetMap does not modify irregularidades
    if (mapRef.current) {
      mapRef.current.panTo(defaultCenter);
      mapRef.current.setZoom(8);
    }
  }, []);

  // Efecto para limpiar recursos cuando el componente se desmonta
  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current = null;
      }
      setMarker(null);
      setResults(null);
      setError(null);
      setNearFieldStatus(null);
      setIsScriptLoaded(false);
    };
  }, []);

  // Efecto para manejar la visibilidad
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && mapRef.current && marker) {
        // Solo actualizar el mapa sin resetear datos
        mapRef.current.panTo({ lat: parseFloat(lat), lng: parseFloat(lng) });
      }
    };
  
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [marker, lat, lng]);

  // Manejadores del mapa
  const handleMapLoad = useCallback((map) => {
    mapRef.current = map;
    setIsScriptLoaded(true);
    
    // Si hay coordenadas guardadas, centrar el mapa en ellas
    if (lat && lng) {
      map.panTo({ lat: parseFloat(lat), lng: parseFloat(lng) });
      map.setZoom(10);
    }
  }, [lat, lng]);
  const handleMapUnmount = useCallback(() => {
    mapRef.current = null;
    setIsScriptLoaded(false);
  }, []);

  // Detectar rechazo de clave de Google Maps (restriccion de dominio)
  useEffect(() => {
    window.gm_authFailure = () => setMapAuthError(true);
    return () => { window.gm_authFailure = undefined; };
  }, []);

  // Auto-recalcular cuando cambian los parametros (si ya hay coordenadas)
  useEffect(() => {
    if (!lat || !lng) return;
    const timer = setTimeout(calculateParameters, 400);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const handleMapClick = (event) => {
    try {
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();
      setMarker({ lat: newLat, lng: newLng });
      setLat(newLat.toFixed(6));
      setLng(newLng.toFixed(6));
  
      // Verificar campo cercano
      const status = checkNearField(newLng, newLat);
      setNearFieldStatus(status);
      
      // Validar coordenadas
      if (newLat < 17.5 || newLat > 20.0 || newLng < -75.0 || newLng > -68.0) {
        throw new Error('Las coordenadas estan fuera del rango valido para Republica Dominicana');
      }
  
      // Calcular valores Ss y S1
      const basicParams = calculateSeismicParameters(newLat, newLng);
  
      const analisis = new AnalisisSismico({
        tipo_suelo:          params.tipoSuelo,
        categoria_riesgo:    params.categoriaRiesgo,
        ss:                  basicParams.ss,
        s1:                  basicParams.s1,
        campo_cercano:       status.isNearField,
        sistema_estructural: params.sistemaEstructural,
        altura:              parseFloat(params.altura),
        irregularidades:     params.irregularidades,
      });

      setResults(analisis.obtenerResultados());
      setError(null);

    } catch (error) {
      setError(error.message);
      console.error('Error en el calculo:', error);
    }
  };

  const handleCoordinateChange = (e, coord) => {
    try {
      const value = e.target.value;
      if (coord === 'lat') setLat(value);
      else setLng(value);

      const latitude  = coord === 'lat' ? value : lat;
      const longitude = coord === 'lng' ? value : lng;

      if (latitude && longitude) {
        const numLat = parseFloat(latitude);
        const numLng = parseFloat(longitude);

        setMarker({ lat: numLat, lng: numLng });

        const status = checkNearField(numLng, numLat);
        setNearFieldStatus(status);

        if (numLat < 17.5 || numLat > 20.0 || numLng < -75.0 || numLng > -68.0) {
          throw new Error('Las coordenadas estan fuera del rango valido para Republica Dominicana');
        }

        const basicParams = calculateSeismicParameters(numLat, numLng);

        const analisis = new AnalisisSismico({
          tipo_suelo:          params.tipoSuelo,
          categoria_riesgo:    params.categoriaRiesgo,
          ss:                  basicParams.ss,
          s1:                  basicParams.s1,
          campo_cercano:       status.isNearField,
          sistema_estructural: params.sistemaEstructural,
          altura:              parseFloat(params.altura),
          irregularidades:     params.irregularidades,
        });

        setResults(analisis.obtenerResultados());
        setError(null);

        if (mapRef.current) mapRef.current.panTo({ lat: numLat, lng: numLng });
      }
    } catch (error) {
      setError(error.message);
      console.error('Error en el calculo:', error);
    }
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name.startsWith('irregularidades.')) {
      const irregularidadName = name.split('.')[1];
      setParams(prev => ({
        ...prev,
        irregularidades: {
          ...prev.irregularidades,
          [irregularidadName]: checked
        }
      }));
    } else {
      setParams(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const clearAll = () => {
    setMarker(null);
    setLat('');
    setLng('');
    setResults(null);
    setNearFieldStatus(null);
    setParams({
      descripcion: '',
      tipoSuelo: 'D',
      categoriaRiesgo: 'II',
      sistemaEstructural: 'Porticos especiales de hormigon armado',
      altura: 12.0,
      irregularidades: {
        pisoSuave:               false,
        pisoDebil:               false,
        masaIrregular:           false,
        discontinuidadSistema:   false,
        irregularidadTorsional:  false,
        reentrantesEnPlanta:     false,
        discontinuidadDiafragma: false,
        sistemasNoParalelos:     false,
      },
    });
    localStorage.removeItem('seismic_marker');
    localStorage.removeItem('seismic_lat');
    localStorage.removeItem('seismic_lng');
    localStorage.removeItem('seismic_params');
    localStorage.removeItem('seismic_results');
    localStorage.removeItem('seismic_nearFieldStatus');
  };

  // ── Descargar datos del espectro como TXT ────────────────────────────────
  const downloadEspectroTXT = () => {
    if (!results?.espectro) return;
    const { t, sa, saMCE, saDiseno } = results.espectro;
    const header = `ESPECTRO DE DISENO - CDCRD 2026\nSDS = ${results.sds?.toFixed(4)}g  SD1 = ${results.sd1?.toFixed(4)}g\nCampo Cercano: ${results.campoCercano ? 'Si' : 'No'}\nSistema: ${results.sistemaEstructural}  R=${results.R}  Ie=${results.Ie}\n\nT(s)\tSa_MCE(g)\tSa_Elastico(g)\tSa_Diseno(g)\n`;
    const rows = t.map((ti, i) =>
      `${ti.toFixed(4)}\t${saMCE[i].toFixed(6)}\t${sa[i].toFixed(6)}\t${saDiseno[i].toFixed(6)}`
    ).join('\n');
    const blob = new Blob([header + rows], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `espectro_CDCRD2026_${results.cds || 'CDS'}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const calculateParameters = () => {
    try {
      setError(null);

      if (!lat || !lng) {
        throw new Error('Seleccione una ubicacion en el mapa o ingrese las coordenadas');
      }

      const latitude  = parseFloat(lat);
      const longitude = parseFloat(lng);

      if (latitude < 17.5 || latitude > 20.0 || longitude < -75.0 || longitude > -68.0) {
        throw new Error('Las coordenadas estan fuera del rango valido para Republica Dominicana');
      }

      const basicParams = calculateSeismicParameters(latitude, longitude);
      const campoCercano = nearFieldStatus?.isNearField ?? false;

      const analisis = new AnalisisSismico({
        tipo_suelo:          params.tipoSuelo,
        categoria_riesgo:    params.categoriaRiesgo,
        ss:                  basicParams.ss,
        s1:                  basicParams.s1,
        campo_cercano:       campoCercano,
        sistema_estructural: params.sistemaEstructural,
        altura:              parseFloat(params.altura),
        irregularidades:     params.irregularidades,
      });

      setResults(analisis.obtenerResultados());

    } catch (error) {
      setError(error.message);
      console.error('Error en el calculo:', error);
    }
  };

  // â”€â”€ CDS color helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const CDS_STYLES = {
    A: { bg: 'bg-emerald-50 border border-emerald-200', text: 'text-emerald-800', badge: 'bg-emerald-100 text-emerald-800' },
    B: { bg: 'bg-yellow-50 border border-yellow-200', text: 'text-yellow-800', badge: 'bg-yellow-100 text-yellow-800' },
    C: { bg: 'bg-orange-50 border border-orange-200', text: 'text-orange-800', badge: 'bg-orange-100 text-orange-800' },
    D: { bg: 'bg-red-50 border border-red-200', text: 'text-red-800', badge: 'bg-red-100 text-red-800' },
    E: { bg: 'bg-red-900', text: 'text-red-100', badge: 'bg-red-800 text-red-100' },
    F: { bg: 'bg-slate-900', text: 'text-slate-100', badge: 'bg-slate-800 text-slate-100' },
  };

  const cdsStyle = results?.cds ? (CDS_STYLES[results.cds] || CDS_STYLES.D) : null;

  // â”€â”€ Grupos de sistemas estructurales â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const gruposSistemas = Object.entries(FACTORES_ESTRUCTURALES).reduce((acc, [k, v]) => {
    if (!acc[v.grupo]) acc[v.grupo] = [];
    acc[v.grupo].push(k);
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      {/* â”€â”€ HEADER â”€â”€ */}
      <div className="bg-blue-900 text-white px-6 py-4 shadow-lg">
        <div className="max-w-[1400px] mx-auto flex items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-blue-700 flex items-center justify-center flex-shrink-0">
            <CalculateOutlined sx={{ fontSize: 22 }} />
          </div>
          <div>
            <h1 className="text-xl font-bold leading-tight">Calculadora Sismica  —  CDCRD 2026</h1>
            <p className="text-blue-300 text-xs">Codigo para el Diseno y Construccion de la Republica Dominicana</p>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 pt-5">
        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        <div className="grid grid-cols-1 xl:grid-cols-[390px_1fr] gap-5">

          {/* â•â•â•â•â•â•â•â•â•â•â•â• LEFT PANEL â•â•â•â•â•â•â•â•â•â•â•â• */}
          <div className="flex flex-col gap-4">

            {/* Descripcion */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
              <p className="text-[11px] font-bold text-blue-700 uppercase tracking-widest mb-3">Proyecto</p>
              <TextField
                fullWidth size="small" label="Descripcion del Proyecto"
                name="descripcion" value={params.descripcion} onChange={handleChange}
              />
            </div>

            {/* Parametros sismicos */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
              <div className="flex items-center justify-between mb-4">
                <p className="text-[11px] font-bold text-blue-700 uppercase tracking-widest">Parametros Sismicos</p>
                {nearFieldStatus && (
                  <span className={`flex items-center gap-1 text-[11px] font-bold px-3 py-1 rounded-full ${
                    nearFieldStatus.isNearField
                      ? 'bg-red-100 text-red-700 border border-red-200'
                      : 'bg-emerald-100 text-emerald-700 border border-emerald-200'
                  }`}>
                    {nearFieldStatus.isNearField
                      ? <><WarningAmberRounded sx={{ fontSize: 13 }} /> Campo Cercano</>
                      : <><CheckCircleOutlineRounded sx={{ fontSize: 13 }} /> Fuera de Campo Cercano</>
                    }
                  </span>
                )}
              </div>
              <div className="grid grid-cols-2 gap-3 mb-3">
                <FormControl size="small" fullWidth>
                  <InputLabel>Tipo de Suelo</InputLabel>
                  <Select name="tipoSuelo" value={params.tipoSuelo} onChange={handleChange} label="Tipo de Suelo">
                    {['A','B','C','D','E'].map(t => (
                      <MenuItem key={t} value={t}>Tipo {t}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" fullWidth>
                  <InputLabel>Categoria de Riesgo Sismico</InputLabel>
                  <Select name="categoriaRiesgo" value={params.categoriaRiesgo} onChange={handleChange} label="Categoria de Riesgo Sismico">
                    {Object.entries(CATEGORIAS_RIESGO).map(([k, v]) => (
                      <MenuItem key={k} value={k}>Cat. {k}  —  Ie = {v.Ie.toFixed(2)}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <TextField
                  size="small" fullWidth label="Latitud" value={lat}
                  onChange={e => handleCoordinateChange(e, 'lat')} type="number"
                  inputProps={{ step: '0.000001', min: '17.5', max: '20.0' }}
                />
                <TextField
                  size="small" fullWidth label="Longitud" value={lng}
                  onChange={e => handleCoordinateChange(e, 'lng')} type="number"
                  inputProps={{ step: '0.000001', min: '-75.0', max: '-68.0' }}
                />
              </div>
              {results && (
                <div className="grid grid-cols-2 gap-2 mt-3">
                  <div className="bg-blue-50 rounded-xl px-3 py-2 text-center border border-blue-100">
                    <div className="text-[10px] text-blue-600 font-bold uppercase tracking-wide">Ss (g)</div>
                    <div className="text-xl font-black text-blue-900">{results.ss?.toFixed(3)}</div>
                  </div>
                  <div className="bg-blue-50 rounded-xl px-3 py-2 text-center border border-blue-100">
                    <div className="text-[10px] text-blue-600 font-bold uppercase tracking-wide">S1 (g)</div>
                    <div className="text-xl font-black text-blue-900">{results.s1?.toFixed(3)}</div>
                  </div>
                </div>
              )}
            </div>

            {/* Sistema Estructural */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
              <p className="text-[11px] font-bold text-blue-700 uppercase tracking-widest mb-4">Sistema Estructural</p>
              <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                <InputLabel>Sistema Estructural</InputLabel>
                <Select
                  name="sistemaEstructural"
                  value={params.sistemaEstructural}
                  onChange={handleChange}
                  label="Sistema Estructural"
                  MenuProps={{ PaperProps: { style: { maxHeight: 380 } } }}
                >
                  {Object.entries(gruposSistemas).flatMap(([grupo, sistemas]) => [
                    <ListSubheader key={grupo} sx={{ fontWeight: 700, color: '#1e40af', bgcolor: '#eff6ff', fontSize: 11, lineHeight: '28px' }}>
                      {grupo}
                    </ListSubheader>,
                    ...sistemas.map(s => (
                      <MenuItem key={s} value={s} sx={{ fontSize: 13, pl: 3, whiteSpace: 'normal' }}>{s}</MenuItem>
                    )),
                  ])}
                </Select>
              </FormControl>
              <TextField
                size="small" fullWidth label="Altura del Edificio (m)"
                name="altura" type="number" value={params.altura}
                onChange={handleChange} InputLabelProps={{ shrink: true }}
              />
              {FACTORES_ESTRUCTURALES[params.sistemaEstructural] && (
                <div className="grid grid-cols-4 gap-2 mt-3">
                  {[
                    ['R',  FACTORES_ESTRUCTURALES[params.sistemaEstructural].R],
                    ['\u03a9\u2080', FACTORES_ESTRUCTURALES[params.sistemaEstructural].Omega0],
                    ['Cd', FACTORES_ESTRUCTURALES[params.sistemaEstructural].Cd],
                    ['Ie', CATEGORIAS_RIESGO[params.categoriaRiesgo]?.Ie ?? '-'],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-slate-50 rounded-xl p-2 text-center border border-slate-200">
                      <div className="text-[10px] text-slate-500 font-semibold">{label}</div>
                      <div className="text-base font-black text-slate-800">{val}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Irregularidades */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
              <p className="text-[11px] font-bold text-blue-700 uppercase tracking-widest mb-1">Irregularidades CDCRD 2026</p>
              <p className="text-xs text-slate-400 mb-3">Aplica ρ = 1.3 si hay alguna irregularidad</p>
              <div className="space-y-0.5">
                {[
                  ['irregularidades.pisoSuave',              'Piso Suave (Vertical Tipo 1)'],
                  ['irregularidades.pisoDebil',              'Piso Debil (Vertical Tipo 5)'],
                  ['irregularidades.masaIrregular',          'Masa Irregular (Vertical Tipo 2)'],
                  ['irregularidades.discontinuidadSistema',  'Discontinuidad Vertical (Tipo 4)'],
                  ['irregularidades.irregularidadTorsional', 'Torsional (Horizontal Tipo 1)'],
                  ['irregularidades.reentrantesEnPlanta',    'Reentrantes en Planta (Tipo 2)'],
                  ['irregularidades.discontinuidadDiafragma','Discontinuidad Diafragma (Tipo 3)'],
                  ['irregularidades.sistemasNoParalelos',    'Sistemas No Paralelos (Tipo 5)'],
                ].map(([name, label]) => {
                  const key = name.split('.')[1];
                  return (
                    <FormControlLabel
                      key={name}
                      control={
                        <Checkbox
                          size="small"
                          checked={params.irregularidades[key] || false}
                          onChange={handleChange}
                          name={name}
                          sx={{ '&.Mui-checked': { color: '#1d4ed8' }, py: 0.5 }}
                        />
                      }
                      label={<span className="text-sm text-slate-700">{label}</span>}
                      sx={{ display: 'flex', m: 0 }}
                    />
                  );
                })}
              </div>
            </div>

            {/* Botones */}
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="contained" fullWidth onClick={calculateParameters}
                startIcon={<CalculateOutlined />}
                sx={{ bgcolor: '#1e40af', '&:hover': { bgcolor: '#1e3a8a' }, borderRadius: 2, py: 1.2, textTransform: 'none', fontWeight: 700 }}
              >
                Calcular
              </Button>
              <Button
                variant="outlined" fullWidth onClick={clearAll}
                startIcon={<CleaningServices />}
                sx={{ borderRadius: 2, py: 1.2, textTransform: 'none', borderColor: '#cbd5e1', color: '#64748b' }}
              >
                Limpiar
              </Button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="outlined" fullWidth disabled={!results}
                startIcon={<SaveAlt />}
                onClick={() => generatePDF(results, { ...params, lat, lng }, nearFieldStatus, chartRef)}
                sx={{ borderRadius: 2, py: 1.2, textTransform: 'none', borderColor: '#cbd5e1', color: '#64748b' }}
              >
                Descargar PDF
              </Button>
              <Button
                variant="outlined" fullWidth disabled={!results?.espectro}
                startIcon={<SaveAlt />}
                onClick={downloadEspectroTXT}
                sx={{ borderRadius: 2, py: 1.2, textTransform: 'none', borderColor: '#0ea5e9', color: '#0369a1' }}
              >
                Datos Espectro
              </Button>
            </div>
          </div>

          {/* â•â•â•â•â•â•â•â•â•â•â•â• RIGHT PANEL â•â•â•â•â•â•â•â•â•â•â•â• */}
          <div className="flex flex-col gap-4">

            {/* Mapa */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
              <div className="px-5 py-3 border-b border-slate-100 flex items-center justify-between">
                <span className="text-sm font-semibold text-slate-700">Ubicacion del Proyecto</span>
                {nearFieldStatus && (
                  <span className={`flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full ${nearFieldStatus.isNearField ? 'bg-red-100 text-red-700' : 'bg-emerald-100 text-emerald-700'}`}>
                    {nearFieldStatus.isNearField
                      ? <><WarningAmberRounded sx={{ fontSize: 14 }} /> Campo Cercano: {nearFieldStatus.areaName}</>
                      : <><CheckCircleOutlineRounded sx={{ fontSize: 14 }} /> Fuera de campo cercano</>
                    }
                  </span>
                )}
              </div>
              <div style={{ height: '430px', position: 'relative' }}>
                <LoadScript
                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyBMUW5x88AqL1T-EcmLtCiNXYS1V2C36R8"}
                  onLoad={() => setIsScriptLoaded(true)}
                  onError={() => setIsScriptLoaded(false)}
                >
                  {isScriptLoaded && (
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      center={defaultCenter}
                      zoom={8}
                      onClick={handleMapClick}
                      options={mapOptions}
                      onLoad={handleMapLoad}
                      onUnmount={handleMapUnmount}
                    >
                      {marker && <Marker position={marker} />}
                    </GoogleMap>
                  )}
                </LoadScript>
                {mapAuthError && (
                  <div className="absolute inset-0 z-10 flex items-center justify-center bg-amber-50 rounded-xl border border-amber-200">
                    <div className="text-center p-6 max-w-xs">
                      <div className="text-amber-500 text-4xl mb-3">⚠</div>
                      <p className="text-amber-800 font-semibold mb-2">Clave de Maps no autorizada</p>
                      <p className="text-xs text-slate-600 mb-3">Este dominio de Vercel no está en la lista de referidores permitidos de la API key.</p>
                      <p className="text-xs text-slate-500">Ir a <strong>Google Cloud Console → Credenciales</strong> y agregar <code className="bg-amber-100 px-1 rounded">*.vercel.app</code> a los HTTP referrers permitidos.</p>
                      <p className="text-xs text-slate-400 mt-3">También puedes ingresar las coordenadas manualmente:</p>
                    </div>
                  </div>
                )}
                {!isScriptLoaded && !mapAuthError && (
                  <div className="h-full flex items-center justify-center bg-slate-50">
                    <div className="text-center">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-3"></div>
                      <p className="text-sm text-slate-500">Cargando mapa...</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* â”€â”€ RESULTADOS â”€â”€ */}
            {results && results.sds && (
              <>
                {/* Banner CDS + ρ */}
                <div className={`rounded-2xl p-5 flex items-center justify-between shadow-sm ${cdsStyle?.bg}`}>
                  <div>
                    <div className={`text-[10px] font-bold uppercase tracking-widest mb-1 opacity-70 ${cdsStyle?.text}`}>
                      Categoria de Diseno Sismico
                    </div>
                    <div className={`text-5xl font-black ${cdsStyle?.text}`}>CDS {results.cds}</div>
                  </div>
                  <div className="text-right">
                    <div className={`text-[10px] font-bold uppercase tracking-widest mb-1 opacity-70 ${cdsStyle?.text}`}>
                      Factor de Redundancia
                    </div>
                    <div className={`text-4xl font-black ${cdsStyle?.text}`}>ρ = {results.rho?.toFixed(1)}</div>
                  </div>
                </div>

                {/* Parametros espectrales */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: 'SDS (g)', value: results.sds?.toFixed(3), color: 'blue' },
                    { label: 'SD1 (g)', value: results.sd1?.toFixed(3), color: 'blue' },
                    { label: 'Fa',      value: results.fa?.toFixed(3),  color: 'indigo' },
                    { label: 'Fv',      value: results.fv?.toFixed(3),  color: 'indigo' },
                  ].map(({ label, value, color }) => (
                    <div key={label} className="bg-white rounded-xl p-3 text-center shadow-sm border border-slate-100">
                      <div className={`text-[10px] font-bold text-${color}-600 uppercase tracking-wide mb-1`}>{label}</div>
                      <div className="text-2xl font-black text-slate-900">{value}</div>
                    </div>
                  ))}
                </div>

                {/* Factores del sistema */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: 'R (Reduccion)',   value: results.R,               color: 'violet' },
                    { label: 'Ie (Importancia)',value: results.Ie?.toFixed(2),  color: 'violet' },
                    { label: 'Ω₀ (Sobreresist.)',value: results.Omega0,         color: 'violet' },
                    { label: 'Cd (Amplif. def.)', value: results.Cd,            color: 'violet' },
                  ].map(({ label, value, color }) => (
                    <div key={label} className="bg-white rounded-xl p-3 text-center shadow-sm border border-slate-100">
                      <div className={`text-[10px] font-bold text-${color}-600 uppercase tracking-wide mb-1`}>{label}</div>
                      <div className="text-2xl font-black text-slate-900">{value}</div>
                    </div>
                  ))}
                </div>

                {/* Periodos */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: 'Ta (s)',     value: results.ta?.toFixed(3),     color: 'emerald' },
                    { label: 'Cu-Ta (s)', value: results.ta_max?.toFixed(3), color: 'emerald' },
                    { label: 'T0 (s)',    value: results.t0?.toFixed(3),     color: 'teal' },
                    { label: 'Ts (s)',    value: results.ts?.toFixed(3),     color: 'teal' },
                  ].map(({ label, value, color }) => (
                    <div key={label} className="bg-white rounded-xl p-3 text-center shadow-sm border border-slate-100">
                      <div className={`text-[10px] font-bold text-${color}-600 uppercase tracking-wide mb-1`}>{label}</div>
                      <div className="text-2xl font-black text-slate-900">{value}</div>
                    </div>
                  ))}
                </div>

                {/* Cs  —  tarjeta destacada */}
                <div className="bg-blue-800 rounded-2xl p-5 shadow-sm">
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <div>
                      <div className="text-blue-300 text-[10px] font-bold uppercase tracking-widest mb-1">
                        Coeficiente Sismico de Diseno (CDCRD 2026)
                      </div>
                      <div className="text-white text-5xl font-black">Cs = {results.cs?.toFixed(4)}</div>
                      <div className="text-blue-300 text-xs mt-1">Cs,min = {results.cs_min?.toFixed(4)}</div>
                    </div>
                    <div className="text-right text-white font-mono text-sm">
                      <div className="text-blue-300 text-[10px] uppercase tracking-wide mb-1">Formulacion</div>
                      <div>Cs = Sa(T)-Ie/R-ρ</div>
                      <div className="text-blue-300">= {results.sa_design?.toFixed(3)}-{results.Ie?.toFixed(2)}/{results.R}-{results.rho?.toFixed(1)}</div>
                    </div>
                  </div>
                </div>

                {/* Espectro */}
                {results.espectro && (
                  <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-semibold text-slate-700">Espectro de Diseno  —  CDCRD 2026</span>
                      <span className="text-xs text-slate-400">
                        SDS = {results.sds?.toFixed(3)}g &nbsp; SD1 = {results.sd1?.toFixed(3)}g
                        {results.espectro.campoCercano && (
                          <span className="ml-2 text-red-600 font-semibold">· Campo Cercano</span>
                        )}
                      </span>
                    </div>
                    {/* Leyenda */}
                    <div className="flex gap-4 mb-2 text-xs text-slate-500">
                      <span className="flex items-center gap-1">
                        <span style={{ display:'inline-block', width:20, height:3, background:'#3b82f6', borderRadius:2 }} />
                        Sa Elastico Diseno (g)
                      </span>
                      <span className="flex items-center gap-1">
                        <span style={{ display:'inline-block', width:20, height:3, background:'#f97316', borderRadius:2 }} />
                        Sa Inelastico (g)
                      </span>
                    </div>
                    <div style={{ width: '100%', height: 300 }} ref={chartRef}>
                      <ResponsiveContainer>
                        <LineChart
                          data={results.espectro.t.map((t, i) => ({
                            T: Number(t.toFixed(3)),
                            'Sa Elastico (g)':   Number(results.espectro.sa[i].toFixed(4)),
                            'Sa Inelastico (g)': Number(results.espectro.saDiseno[i].toFixed(4)),
                          }))}
                          margin={{ top: 5, right: 20, left: 10, bottom: 30 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                          <XAxis
                            dataKey="T"
                            label={{ value: 'Periodo T (s)', position: 'insideBottom', offset: -10 }}
                            tick={{ fontSize: 11 }}
                          />
                          <YAxis
                            label={{ value: 'Sa (g)', angle: -90, position: 'insideLeft', offset: 5 }}
                            tick={{ fontSize: 11 }}
                          />
                          <Tooltip
                            formatter={v => v.toFixed(4)}
                            labelFormatter={v => `T = ${Number(v).toFixed(3)} s`}
                          />
                          <Line type="monotone" dataKey="Sa Elastico (g)"   stroke="#3b82f6" dot={false} strokeWidth={2.5} />
                          <Line type="monotone" dataKey="Sa Inelastico (g)" stroke="#f97316" dot={false} strokeWidth={2} strokeDasharray="6 3" />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                )}

                {/* Combinaciones de carga */}
                <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
                  <p className="text-[11px] font-bold text-blue-700 uppercase tracking-widest mb-3">
                    Combinaciones de Carga Sismicas  —  CDCRD 2026
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-mono text-sm">
                    {[
                      'C1 = 1.4CM',
                      'C2 = 1.2CM + 1.6CV',
                      `C3 = ${(1.2 + 0.2 * results.sds).toFixed(3)}CM + CV + QEx`,
                      `C4 = ${(1.2 + 0.2 * results.sds).toFixed(3)}CM + CV + QEy`,
                      `C5 = ${(0.9 - 0.2 * results.sds).toFixed(3)}CM + QEx`,
                      `C6 = ${(0.9 - 0.2 * results.sds).toFixed(3)}CM + QEy`,
                    ].map(c => (
                      <div key={c} className="bg-slate-50 rounded-lg px-3 py-2 text-slate-700 border border-slate-100">{c}</div>
                    ))}
                  </div>
                  <p className="text-xs text-slate-400 mt-2">
                    CM = Carga Muerta - CV = Carga Viva - QE = Fuerza sismica horizontal (incluye ρ)
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeismicMap;
